import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostListener,
    input,
    InputSignal,
    Output,
} from '@angular/core';
import { DeviceType } from '../../models/enums/device-type.enum';
import { DeviceTypeLabelComponent } from '../device-type-label/device-type-label.component';

@Component({
    selector: 'web-device-card',
    imports: [DeviceTypeLabelComponent],
    templateUrl: './device-card.component.html',
    styleUrls: ['./device-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceCardComponent {
    @Output()
    onclick: EventEmitter<void> = new EventEmitter<void>();

    type: InputSignal<DeviceType | undefined> = input<DeviceType>();
    name: InputSignal<string | undefined> = input<string>();
    serialNumber: InputSignal<string | undefined> = input<string>();
    asset: InputSignal<string | undefined> = input<string>();
    format: InputSignal<'auto' | 'small' | 'large'> = input<'auto' | 'small' | 'large'>('auto');

    @HostListener('click') clicked(): void {
        this.onclick.emit();
    }
}
